const routes = [
    {
        path: '/gestor/PainelGestorBI',
        name: 'gestor.tableau.index',
        component: () => import('../components/PainelGestorBI.vue'),
        meta: {
            middleware: ['auth'],
            controller: 'PainelGestorController'
        }
    }
];

export default routes;